import { makeStyles } from 'tss-react/mui';
import { colors, theme } from '../../../theme';

/**
 * Custom hook that defines the styles for the challenge modal component.
 */
const useTicTacToeModalStyles = makeStyles()(() => ({
  modalStyles: {
    'display': 'flex',
    'flexDirection': 'column',
    'justifyContent': 'center',
    'alignItems': 'center',
    'position': 'absolute',
    'top': '50%',
    'left': '50%',
    'transform': 'translate(-50%, -50%)',
    'width': '20vw',
    'minWidth': 'fit-content',
    'height': 'fit-content',
    'backgroundColor': colors.white,
    'padding': theme.padding.l,
    'borderRadius': theme.borderRadius.s,
    'border': 'none',
    'boxShadow': `2px 2px 5px 5px ${colors.gray['400']}`,
    '&:focus': {
      outline: 'none',
    },
  },
  titleText: {
    marginBottom: '20px',
  },
  playingAgainst: {
    marginBottom: '10px',
  },
  selfContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '10px',
  },
  youAre: {
    marginRight: '5px',
  },
  challengerIcon: {
    width: '20px',
    height: '20px',
    backgroundImage: 'url(assets/gamepieces/red_x.png)',
    backgroundSize: '20px',
  },
  challengedIcon: {
    width: '20px',
    height: '20px',
    backgroundImage: 'url(assets/gamepieces/blue_o.png)',
    backgroundSize: '20px',
  },
  status: {
    marginBottom: '10px',
  },
  quit: {
    'background': colors.red['500'],
    'marginTop': '25px',
    'border': 'none',
    '&:hover': {
      backgroundColor: colors.red['600'],
    },
    'width': '100px',
  },
  win: {
    'background': colors.green['500'],
    '&:hover': {
      backgroundColor: colors.green['600'],
    },
  },
  buttonRows: {
    position: 'relative',
    display: 'flex',
    flex: '1',
    flexDirection: 'column',
    height: '300px',
    alignItems: 'center',
  },
  buttonColumns: {
    display: 'flex',
    flex: '1',
    height: '300px',
  },
  overlay: {
    position: 'absolute',
    background: 'gray',
    opacity: 0.5,
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 2,
  },
  button: {
    border: `1.5px solid ${colors.black}`,
    width: '100px',
    height: '100px',
  },
  occByChallenger: {
    backgroundImage: 'url(assets/gamepieces/red_x.png)',
    backgroundSize: '90px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '5px, 5px',
  },
  occByChallenged: {
    backgroundImage: 'url(assets/gamepieces/blue_o.png)',
    backgroundSize: '90px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '5px, 5px',
  },
  unOcc: {
    '&:hover': {
      background: theme.background.light,
      cursor: 'pointer',
    },
  },
}));

export default useTicTacToeModalStyles;
